import { render, staticRenderFns } from "./HivesInducedTypesBlock.vue?vue&type=template&id=e396b068&lang=pug&"
import script from "./HivesInducedTypesBlock.vue?vue&type=script&lang=js&"
export * from "./HivesInducedTypesBlock.vue?vue&type=script&lang=js&"
import style0 from "./HivesInducedTypesBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports